import { makeVar } from '@apollo/client/cache';

export const helpDrawerVar = makeVar(false);

/** DD-3780: a question to ask the help assistant as soon as its chat opens. */
export const assistantQuestionVar = makeVar<string | undefined>(undefined);
